import {
  IdCardAddFormValues,
  IdCardPostRequestDto,
  IdCardRequest,
} from '../types';

export const mapIdCardAddDto = (
  idCard: IdCardRequest,
  values: IdCardAddFormValues
): IdCardPostRequestDto => {
  const idCardRequest: IdCardPostRequestDto = {
    ecard: {
      created_by: idCard.createdBy,
      updated_by: idCard.updatedBy,
      display_order: idCard.displayOrder,
      front_image: values.frontImage.src,
      icon_code: values.name,
      name: values.name,
    },
  };
  if (idCard.backImage) {
    idCardRequest.ecard.back_image = values.backImage.src;
  }
  return idCardRequest;
};
